import { LoanStatusType, LoanStatusOptions } from '../LoanConstants';

export const getStatusTypeShortName = (typeId: LoanStatusType) => {
    const item = LoanStatusOptions.find((a) => {
        return a.id === typeId;
    });
    return item?.shortName ?? '';
};
